// extracted by mini-css-extract-plugin
export default {"meeting-link":"styles_meeting-link__+-Kk3","meeting-link__form":"styles_meeting-link__form__HCNiJ"};